import { clsx } from 'clsx'

interface SkeletonProps {
  className?: string
  variant?: 'text' | 'circular' | 'rectangular'
  width?: string | number
  height?: string | number
}

export function Skeleton({ className, variant = 'text', width, height }: SkeletonProps) {
  return (
    <div
      className={clsx(
        'skeleton-pulse bg-slate-700',
        variant === 'text' && 'h-4 rounded',
        variant === 'circular' && 'rounded-full',
        variant === 'rectangular' && 'rounded-xl',
        className,
      )}
      style={{ width, height }}
      aria-hidden="true"
    />
  )
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div className={clsx('rounded-xl border border-slate-700/50 bg-slate-800/80 p-6', className)}>
      <Skeleton className="mb-2 w-24" />
      <Skeleton className="h-8 w-32" />
    </div>
  )
}

export function SkeletonRow() {
  return (
    <div className="flex items-center justify-between rounded-lg border border-slate-700/50 bg-slate-800/80 px-4 py-3">
      <div className="flex items-center gap-3">
        <Skeleton variant="circular" width={36} height={36} />
        <div>
          <Skeleton className="mb-1 w-32" />
          <Skeleton className="w-24 h-3" />
        </div>
      </div>
      <Skeleton className="w-16" />
    </div>
  )
}
